import React from 'react';



type Props = {
  className?: string;
}
export const ReportVector: React.FC<Props> = ({ className }) => {
  return (
    <svg className = { className } width = '24' height = '24' viewBox = '0 0 24 24' fill = 'none' xmlns = 'http://www.w3.org/2000/svg'>
      <path stroke = 'currentColor' strokeWidth = '2' d = 'M5 12V8L10 3H19V21H12M10 18H6M6 18H2M6 18V14M6 18V22' />
      <line stroke = 'currentColor' strokeWidth = '2' y1 = '-1' x2 = '7' y2 = '-1' transform = 'matrix(-1 0 0 1 16 12)' />
      <line stroke = 'currentColor' strokeWidth = '2' y1 = '-1' x2 = '4' y2 = '-1' transform = 'matrix(-1 0 0 1 16 16)' />
      <line stroke = 'currentColor' strokeWidth = '2' y1 = '-1' x2 = '5' y2 = '-1' transform = 'matrix(-1 0 0 1 16 8)' />
    </svg>
  );
};
